import { withDependencies } from '@wix/thunderbolt-ioc'
import { DynamicModelSymbol, FetchAccessTokensSymbol, LoggerSymbol } from '@wix/thunderbolt-symbols'
import type { ILogger, DynamicSessionModel, FetchDynamicModel } from '@wix/thunderbolt-symbols'
import type { ISessionProvider } from './types'

export const ClientSessionProvider = withDependencies(
	[DynamicModelSymbol, FetchAccessTokensSymbol, LoggerSymbol],
	(dynamicModel: DynamicSessionModel, fetchAccessTokens: FetchDynamicModel, logger: ILogger): ISessionProvider => {
		let currentSession: Partial<DynamicSessionModel> = dynamicModel

		return {
			getCurrentSession: () => {
				return currentSession
			},
			loadNewSession: async ({ authorizationCode }) => {
				try {
					currentSession = await fetchAccessTokens({
						credentials: 'same-origin',
						...(authorizationCode && { headers: { authorization: authorizationCode } }),
					})

					return currentSession
				} catch (error) {
					logger.captureError(new Error(`failed fetching dynamicModel`), {
						tags: { feature: 'session-manager', fetchFail: 'dynamicModel' },
						extra: { errorMessage: error.message },
					})
					throw error
				}
			},
		}
	}
)
